import classNames from 'classnames';
import React from 'react';

/**
 * @typedef RadioButtonProps
 * @property {string | undefined} id
 * @property {string | undefined} name
 * @property {string} text
 * @property {boolean} checked
 * @property {React.ChangeEventHandler<HTMLInputElement> | undefined} checked
 * @property {boolean} isValid
 * @property {boolean} isValidated
 */

export const RadioButton = (
  /** @type {RadioButtonProps} */ {
    id,
    name,
    text,
    checked = false,
    onChange,
    isValid,
    isValidated,
  }
) => {
  const classes = classNames('c-quiz-radio-button', {
    '': !isValidated,
    'is-valid': isValidated && isValid,
    'is-invalid': isValidated && !isValid,
    inactive: isValidated,
  });

  const handleKeyDown = (event) => {
    if (event.key === ' ') {
      event.preventDefault();
      onChange({ target: { checked: !checked } });
    }
  };

  return (
    <label className={classes} onKeyDown={handleKeyDown} tabIndex={0}>
      <input
        className="c-quiz-radio-button__input"
        type="radio"
        id={id}
        name={name}
        checked={checked}
        onChange={onChange}
        tabIndex={-1}
      />
      <div className="c-quiz-radio-button__icon"></div>
      <span className="c-quiz-radio-button__text">{text}</span>
    </label>
  );
};
